const styleElement = document.createElement("dom-module");

styleElement.innerHTML = /*html*/`<template>
  <style>
    :host {
      display: block;
    }

    .add-limit-modal__overlay {
      position: fixed;
      inset: 0;
      z-index: 100;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px;
      box-sizing: border-box;
    }

    .add-limit-modal__dialog {
      position: relative;
      width: 444px;
      height: 580px;
      max-height: calc(100vh - 48px);
      overflow-y: auto;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 12px;
      flex-shrink: 0;
    }

    .add-limit-modal__close-btn {
      position: absolute;
      top: 16px;
      right: 16px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: pointer;
      z-index: 1;
    }

    .add-limit-modal__close-btn:focus-visible {
      outline: 2px solid #3570d2;
      outline-offset: 2px;
      border-radius: 4px;
    }

    .add-limit-modal__close-btn img {
      display: block;
      width: 20px;
      height: 20px;
    }

    .add-limit-modal__copy {
      position: absolute;
      top: 48px;
      left: 40px;
      width: 364px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      text-align: center;
      box-sizing: border-box;
    }

    .add-limit-modal__title {
      margin: 0;
      width: 100%;
      font-family: "Lato", sans-serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 100%;
      letter-spacing: 0;
      color: #000000;
    }

    .add-limit-modal__description {
      margin: 0;
      width: 100%;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
      color: #424242;
    }

    .add-limit-modal__illustration {
      position: absolute;
      top: 197px;
      left: 47px;
      width: 349px;
      height: 219px;
      display: block;
      object-fit: contain;
      object-position: center;
      box-sizing: border-box;
    }

    .add-limit-modal__cta-text {
      position: absolute;
      top: 410px;
      left: 67px;
      width: 310px;
      min-height: 48px;
      margin: 0;
      box-sizing: border-box;
      text-align: center;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
      color: #424242;
      white-space: pre-line;
    }

    .add-limit-modal__store-links {
      position: absolute;
      top: 502px;
      left: 87px;
      width: 270px;
      display: flex;
      justify-content: center;
      gap: 24px;
      box-sizing: border-box;
    }

    .add-limit-modal__store-image {
      display: block;
      height: 48px;
      width: auto;
    }
  </style>
</template>`;

styleElement.register("add-limit-modal-style");
